(function() {
      if (window.declockCardProductGalleryReadyV18) return;
      window.declockCardProductGalleryReadyV18 = true;

      var mobileQuery = window.matchMedia('(max-width: 989px)');
      var tap = {
        gallery: null,
        startX: 0,
        startY: 0,
        lastX: 0,
        lastY: 0,
        startIndex: 0,
        scrollLeft: 0,
        moved: false
      };

      function closest(target, selector) {
        return target && target.closest ? target.closest(selector) : null;
      }

      function galleries() {
        return document.querySelectorAll('[data-declock-card-gallery]');
      }

      function images(gallery) {
        return gallery.querySelectorAll('[data-declock-card-gallery-image]');
      }

      function galleryScope(element) {
        return (
          closest(element, '.product-card-wrapper') ||
          closest(element, '.declock-card-media-frame') ||
          closest(element, '.card__media') ||
          element.parentElement ||
          element
        );
      }

      function galleryFromControl(control) {
        var scope = galleryScope(control);
        return scope ? scope.querySelector('[data-declock-card-gallery]') : null;
      }

      function controls(gallery) {
        var scope = galleryScope(gallery);
        return scope ? scope.querySelectorAll('[data-declock-card-gallery-control]') : [];
      }

      function progressBar(gallery) {
        var scope = galleryScope(gallery);
        return scope ? scope.querySelector('[data-declock-card-gallery-bar]') : null;
      }

      function galleryArrows(gallery) {
        var scope = galleryScope(gallery);
        return scope ? scope.querySelectorAll('[data-declock-card-gallery-arrow]') : [];
      }

      function setBarProgress(gallery, progress) {
        var bar = progressBar(gallery);
        var count = images(gallery).length;

        if (!bar || !count) return;

        progress = Math.max(0, Math.min(count - 1, progress));
        bar.style.setProperty('--declock-card-gallery-count', String(count));
        bar.style.setProperty('--declock-card-gallery-progress', String(progress));
      }

      function activeIndex(gallery) {
        var galleryImages = images(gallery);

        if (!mobileQuery.matches) {
          var stored = parseInt(gallery.dataset.declockCardActiveIndex || '0', 10);
          if (!isNaN(stored)) return Math.max(0, Math.min(galleryImages.length - 1, stored));

          for (var index = 0; index < galleryImages.length; index += 1) {
            if (galleryImages[index].classList.contains('is-active')) return index;
          }
        }

        var width = gallery.clientWidth || 1;
        return Math.max(0, Math.min(galleryImages.length - 1, Math.round(gallery.scrollLeft / width)));
      }

      function scrollProgress(gallery) {
        var width = gallery.clientWidth || 1;
        return gallery.scrollLeft / width;
      }

      function setActive(gallery, index) {
        var galleryImages = images(gallery);
        var galleryControls = controls(gallery);

        if (!galleryImages.length) return;

        index = Math.max(0, Math.min(galleryImages.length - 1, index));
        gallery.dataset.declockCardActiveIndex = String(index);
        gallery.classList.add('has-active-image');

        Array.prototype.forEach.call(galleryImages, function(image, imageIndex) {
          var isActive = imageIndex === index;
          image.classList.toggle('is-active', isActive);
          image.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        Array.prototype.forEach.call(galleryControls, function(control, controlIndex) {
          var isActive = controlIndex === index;
          control.classList.toggle('is-active', isActive);
          if (isActive) {
            control.setAttribute('aria-current', 'true');
          } else {
            control.removeAttribute('aria-current');
          }
        });
      }

      function scrollToIndex(gallery, index) {
        if (!gallery || !mobileQuery.matches) return;

        var count = images(gallery).length;
        if (count < 2) return;

        index = Math.max(0, Math.min(count - 1, index));
        gallery.scrollTo({
          left: index * gallery.clientWidth,
          behavior: 'smooth'
        });
      }

      function changeDesktopImage(gallery, direction) {
        if (!gallery) return;

        var count = images(gallery).length;
        if (count < 2) return;

        var current = parseInt(gallery.dataset.declockCardActiveIndex || '0', 10);
        if (isNaN(current)) current = 0;

        var next = direction === 'prev' ? current - 1 : current + 1;
        if (next < 0) next = count - 1;
        if (next >= count) next = 0;

        setActive(gallery, next);
        setBarProgress(gallery, next);
      }

      function stopArrowEvent(event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      }

      function holdArrowEvent(event) {
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      }

      function bindDesktopArrows(gallery) {
        var galleryImages = images(gallery);

        Array.prototype.forEach.call(galleryArrows(gallery), function(arrow) {
          arrow.setAttribute('aria-hidden', galleryImages.length > 1 ? 'false' : 'true');

          if (arrow.dataset.declockCardArrowReady === 'true') return;
          arrow.dataset.declockCardArrowReady = 'true';

          arrow.addEventListener(
            'pointerdown',
            function(event) {
              if (mobileQuery.matches) return;
              holdArrowEvent(event);
            },
            true
          );

          arrow.addEventListener(
            'click',
            function(event) {
              if (mobileQuery.matches) return;
              stopArrowEvent(event);

              var arrowGallery = galleryFromControl(arrow);
              changeDesktopImage(arrowGallery, arrow.getAttribute('data-declock-card-gallery-arrow'));
            },
            true
          );
        });
      }

      function finishSwipe(event, clientX, clientY) {
        if (!tap.gallery || !mobileQuery.matches) return false;

        var deltaX = clientX - tap.startX;
        var deltaY = clientY - tap.startY;

        if (Math.abs(deltaX) > 12 && Math.abs(deltaX) > Math.abs(deltaY) + 2) {
          if (event && event.cancelable) event.preventDefault();
          if (event) {
            event.stopPropagation();
            if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          }
          scrollToIndex(tap.gallery, tap.startIndex + (deltaX < 0 ? 1 : -1));
          tap.moved = true;
          return true;
        }

        return false;
      }

      function initGallery(gallery) {
        if (!gallery) return;

        bindDesktopArrows(gallery);

        if (gallery.dataset.declockCardScrollReady === 'true') {
          setActive(gallery, activeIndex(gallery));
          setBarProgress(gallery, scrollProgress(gallery));
          return;
        }

        gallery.dataset.declockCardScrollReady = 'true';
        setActive(gallery, activeIndex(gallery));
        setBarProgress(gallery, scrollProgress(gallery));

        var frame = 0;
        gallery.addEventListener(
          'scroll',
          function() {
            window.cancelAnimationFrame(frame);
            frame = window.requestAnimationFrame(function() {
              setActive(gallery, activeIndex(gallery));
              setBarProgress(gallery, scrollProgress(gallery));
            });
          },
          { passive: true }
        );
      }

      function init() {
        Array.prototype.forEach.call(galleries(), initGallery);
      }

      document.addEventListener(
        'pointerdown',
        function(event) {
          var arrow = closest(event.target, '[data-declock-card-gallery-arrow]');

          if (arrow && !mobileQuery.matches) {
            event.stopPropagation();
            if (event.stopImmediatePropagation) event.stopImmediatePropagation();
            return;
          }

          var gallery = closest(event.target, '[data-declock-card-gallery]');
          if (!gallery || !mobileQuery.matches || closest(event.target, '[data-declock-card-gallery-control]')) return;

          tap.gallery = gallery;
          tap.startX = event.clientX;
          tap.startY = event.clientY;
          tap.lastX = event.clientX;
          tap.lastY = event.clientY;
          tap.startIndex = activeIndex(gallery);
          tap.scrollLeft = gallery.scrollLeft;
          tap.moved = false;
        },
        true
      );

      document.addEventListener(
        'pointermove',
        function(event) {
          if (!tap.gallery) return;

          tap.lastX = event.clientX;
          tap.lastY = event.clientY;

          if (Math.abs(event.clientX - tap.startX) > 4 || Math.abs(event.clientY - tap.startY) > 4) {
            tap.moved = true;
          }
        },
        true
      );

      document.addEventListener(
        'pointerup',
        function(event) {
          finishSwipe(event, event.clientX, event.clientY);
          tap.gallery = null;
        },
        true
      );

      document.addEventListener(
        'pointercancel',
        function(event) {
          finishSwipe(event, tap.lastX, tap.lastY);
          tap.gallery = null;
        },
        true
      );

      document.addEventListener(
        'click',
        function(event) {
          var arrow = closest(event.target, '[data-declock-card-gallery-arrow]');

          if (arrow) {
            var arrowGallery = galleryFromControl(arrow);
            if (!arrowGallery) return;

            event.preventDefault();
            event.stopPropagation();
            if (event.stopImmediatePropagation) event.stopImmediatePropagation();
            changeDesktopImage(arrowGallery, arrow.getAttribute('data-declock-card-gallery-arrow'));
            return;
          }

          var control = closest(event.target, '[data-declock-card-gallery-control]');

          if (control && mobileQuery.matches) {
            var controlGallery = galleryFromControl(control);
            if (!controlGallery) return;

            event.preventDefault();
            event.stopPropagation();
            if (event.stopImmediatePropagation) event.stopImmediatePropagation();
            scrollToIndex(controlGallery, parseInt(control.getAttribute('data-declock-card-gallery-control') || '0', 10));
            return;
          }

          var gallery = closest(event.target, '[data-declock-card-gallery]');
          if (!gallery) return;

          if (mobileQuery.matches) {
            if (tap.moved || Math.abs(gallery.scrollLeft - tap.scrollLeft) > 4) {
              event.preventDefault();
              event.stopPropagation();
              if (event.stopImmediatePropagation) event.stopImmediatePropagation();
              tap.moved = false;
              return;
            }

            event.preventDefault();
            event.stopPropagation();
            if (event.stopImmediatePropagation) event.stopImmediatePropagation();
            if (gallery.dataset.declockCardUrl) window.location.href = gallery.dataset.declockCardUrl;
            return;
          }

          if (gallery.dataset.declockCardUrl) {
            event.preventDefault();
            event.stopPropagation();
            if (event.stopImmediatePropagation) event.stopImmediatePropagation();
            window.location.href = gallery.dataset.declockCardUrl;
          }
        },
        true
      );

      init();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
      } else {
        window.setTimeout(init, 0);
      }
      document.addEventListener('shopify:section:load', init);

      if ('MutationObserver' in window) {
        new MutationObserver(init).observe(document.documentElement, {
          childList: true,
          subtree: true
        });
      }
    })();
